import { Icon } from "~/components/icon";
import { cn } from "~/utils";

export function Checkbox({
  checked,
  onChange,
  ariaLabel,
  onClick,
  className,
}: {
  checked: boolean;
  onChange: (
    checked: boolean,
    event: React.ChangeEvent<HTMLInputElement>,
  ) => void;
  ariaLabel?: string;
  onClick?: (event: React.MouseEvent) => void;
  className?: string;
}) {
  return (
    <span className={cn("relative block h-4 w-4", className)}>
      <input
        type="checkbox"
        checked={checked}
        aria-label={ariaLabel}
        onClick={onClick}
        onChange={(event) => onChange(event.target.checked, event)}
        className="peer m-0 block h-4 w-4 cursor-pointer appearance-none rounded-[3px] border border-gray-300 bg-white transition-colors checked:border-orange-400 checked:bg-orange-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-400 focus-visible:ring-offset-1"
      />
      <Icon
        name="Check"
        size={12}
        className="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-gray-900 opacity-0 [stroke-width:3] peer-checked:opacity-100"
      />
    </span>
  );
}
